import GoodsService from "../services/goods.service";
import WhDocument from '../services/wh-document.service';

const state = {
	itemNotFoundForDep: false,
	itemWithDifferentPrices: [],
	newGood: null,
	createGoodError: null,
	items: [],
	currentEditingItem: null,
	goodsForMultiselect: [],
	photoUploadError: false,
	photoDeleteError: false,
	withKeywordError: false,
	itemWithBarcode: null,
	barcodeError: false,
	isBarcodeTab: false,
	goodsForPos: [],
	total: 0,
	forPosTotal: 0,
	columns: [
		{
			key: 'id',
			label: 'ID',
			visible: true,
			changebale: false
		},
		{
			key: 'multi',
			label: 'goods.special-barcode',
			visible: true,
			changebale: true
		},
		{
			key: 'name',
			label: 'goods.name',
			'class': 'td-30',
			visible: true,
			changebale: true
		},
		{
			key: 'multiBarcode',
			label: 'goods.barcode',
			sortable: true,
			visible: true,
			changebale: true
		},
		{
			key: 'artikul',
			label: 'goods.artikul',
			visible: true,
			changebale: true
		},
		{
			key: 'mxikCode',
			label: 'MXIK',
			visible: true,
			changebale: true
		},
		{
			key: 'colorName',
			label: 'goods.color',
			visible: false,
			changebale: true
		},
		{
			key: 'subCategoryName',
			label: 'goods.create.select-group',
			'class': 'td-30',
			visible: true,
			changebale: true
		},
		{
			key: 'sub2CategoryName',
			label: 'goods.category',
			'class': 'td-30',
			visible: true,
			changebale: true
		},
		{
			key: 'sub3CategoryName',
			label: 'goods.create.select-subcategory',
			'class': 'td-30',
			visible: false,
			changebale: true
		},
		{
			key: 'brandName',
			label: 'goods.brand',
			visible: false,
			changebale: true
		},
		{
			key: 'size',
			label: 'goods.size',
			visible: false,
			changebale: true
		},
		{
			key: 'genderName',
			label: 'goods.gender',
			visible: false,
			changebale: true
		},
		{
			key: 'forPos',
			label: 'goods.create.forPos',
			'class': 'td-30',
			visible: false,
			changebale: true
		},
		{
			key: 'unitName',
			label: 'goods.create.unit',
			'class': 'td-30',
			visible: false,
			changebale: true
		},
		{
			key: 'manufacturerName',
			label: 'goods.manufacture',
			'class': 'td-30',
			visible: false,
			changebale: true
		},
		{
			key: 'weight',
			label: 'goods.weight',
			'class': 'td-30',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key:'contragents',
			label: 'goods.contragents',
			'class': 'td-30',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'sku',
			label: 'goods.sku',
			sortable: true,
			visible: false,
			changebale: true
		},
		{
			key: 'actions',
			label: 'goods.actions',
			'class': 'table_actions',
			visible: true,
			changebale: false
		}

	],
	lastWrappedItems: []
};


const getters = {
	listGoods: (state) => {
		return state.items
	},

	totalItems: (state) => {
		return state.total;
	},
	columns: (state) => {
		return state.columns
	},
	getGoodsForPos: (state) => {
		return state.goodsForPos
	},
	getForPosTotal: (state) => {
		return state.forPosTotal
	}

};


const actions = {
	async fetchItemWithBarcodeForDepBySaleType({commit}, payload) {
		try {
			let response = {};
			if (payload.depSaleType == 'RETAIL') {
				response = await WhDocument.getItemsForDepBySaleTypeRetail(payload);
			} else {
				response = await WhDocument.getItemsForDepBySaleTypeWhole(payload);
			}
			if (Array.isArray(response.data)) {
				if (response.data.length > 1) {
					commit('setItemNotFoundForDep', false);
					commit('setItemWithDifferentPrices', response.data);
				} else if (response.data.length == 0) {
					commit('setItemNotFoundForDep', true);
					commit('setItemWithBarcode', null);
				} else {
					commit('setItemNotFoundForDep', false);
					commit('setItemWithBarcode', response.data[0]);
				}
			}
		} catch (e) {
			commit('setItemWithBarcode', null);
			commit('setItemNotFoundForDep', false);
			commit('setItemWithDifferentPrices', []);
			let response = JSON.parse(e.request.response);
			commit('withBarcodeError', {message: response.message, boolean: true});
			return false
		}
	},
	async fetchItemWithBarcodeScannerForDepBySaleType({commit}, payload) {
		try {
			let response = {};
			if (payload.depSaleType == 'RETAIL') {
				response = await WhDocument.getItemsWithBarcodeForDepBySaleTypeRetail(payload);
			} else {
				response = await WhDocument.getItemsForDepBySaleTypeWhole(payload);
			}
			if (Array.isArray(response.data)) {
				if (response.data.length > 1) {
					commit('setItemNotFoundForDep', false);
					commit('setItemWithDifferentPrices', response.data);
				} else if (response.data.length == 0) {
					commit('setItemNotFoundForDep', true);
					commit('setItemWithBarcode', null);
				} else {
					commit('setItemNotFoundForDep', false);
					commit('setItemWithBarcode', response.data[0]);
				}
			}
		} catch (e) {
			commit('setItemWithBarcode', null);
			commit('setItemNotFoundForDep', false);
			commit('setItemWithDifferentPrices', []);
			let response = JSON.parse(e.request.response);
			commit('withBarcodeError', {message: response.message, boolean: true});
			return false
		}
	},

	/**
	 * Create action
	 * @param commit
	 * @param data
	 * @returns {Promise<boolean>}
	 */
	async createGood({commit}, data) {
		try {
			const good = await GoodsService.storeGood(data);
			commit('newGood', good);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('createGoodError', {message: response.message, boolean: true});
			return false
		}
	},

	/**
	 * Fetch action
	 * @returns {Promise<boolean>}
	 */
	async fetchGoods({commit}, data) {
		try {
			GoodsService.fetchGoods(data).then(response => {
				commit('setGoods', response.data);
			});

		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('fetchGoodError', {message: response.message, boolean: true});
			return false
		}
	},
	async fetchGoodsWithKeyword({commit}, keyword) {
		try {
			const response = await GoodsService.fetchGoodsWithKeyword(keyword);
			commit('setGoodsWithKeyword', response.data);

		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('fetchGoodsWithKeywordError', {message: response.message, boolean: true});
			return false
		}
	},
	async fetchItemWithBarcode({commit}, keyword) {
		try {
			const response = await GoodsService.fetchItemWithBarcode(keyword);
			commit('setItemWithBarcode', response.data);

		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('withBarcodeError', {message: response.message, boolean: true});
			return false
		}
	},
	async fetchItemWithBarcodeNotIncome({commit}, payload) {
		try {
			const response = await GoodsService.fetchItemWithBarcodeNotIncomeService(payload);
			commit('setItemWithBarcode', response.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('withBarcodeError', {message: response.message, boolean: true});
			return false
		}
	},

	async fetchSearchGoodsForPos({commit}, data) {
		try {
			GoodsService.getSearchForPos(data).then(response => {
				commit('setGoodsForPos', response.data.items);
				commit('setGoodsForPosTotal', response.data.total);
			});

		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('fetchGoodError', {message: response.message, boolean: true});
			return false
		}
	},
	async getItemImagesById({commit}, itemId) {
		try {
			let response = await GoodsService.getItemImages(itemId);
			commit('setCurrentItemImages', response.data);
		} catch (e) {
			commit('setCurrentItemImages', []);
			return false;
		}
	},
	 async setMainPhotoById({commit}, itemIdAndPhotoId) {
 	 	try {
 	 		let response = await GoodsService.setMainPhoto(itemIdAndPhotoId.itemId, itemIdAndPhotoId.photoId);
 	 		commit('setMainPhotoForCurrentItem', response.data);
 	 	} catch (e) {
 	 		commit('setMainPhotoForCurrentItem', null);
 	 		return false;
 	 	}
 	 },
 	 async uploadPhotoForCurrentItem({state, commit}, form) {
 	 	try {
 	 		let response = await GoodsService.uploadPhoto(state.currentEditingItem.id, form);
 	 		commit('pushNewPhotoToCurrentItem', response.data);
 	 		commit('setPhotoUploadError', {message: false, boolean: false});
 	 	} catch (e) {
 			commit('setPhotoUploadError', {message: 'Размер файла слишком велик', boolean: true});
 			return false;
 		}
 	},
 	async deletePhotoById({commit}, itemIdAndPhotoId) {
 		try {
 			let response = await GoodsService.deletePhoto(itemIdAndPhotoId.itemId, itemIdAndPhotoId.photoId);
 			commit('deletePhotoFromCurrentItem', response.data);
 			commit('setPhotoDeleteError', {message: false, boolean: false});
 		} catch (e) {
 			commit('setPhotoDeleteError', {message: 'Пожалуйста, попробуйте еще раз чуть позже', boolean: true});
 			return false;
 		}
 	},
 	updateColumns({commit}, data) {
 		commit('setColumn', data)
 	},
 	async getWrappedItemsById({commit}, payload) {
 		try {
 			let response = await GoodsService.getWrappedItemsByIdService(payload);
 			commit('setLastWrappedItems', response.data);
 		} catch (e) {
 			commit('setLastWrappedItems', []);
 			return false;
 		}
 	}
 };

 const mutations = {
 	setItemNotFoundForDep(state, boolean) {
 		state.itemNotFoundForDep = boolean;
 	},

 	setItemWithDifferentPrices(state, payload) {
 		state.itemWithDifferentPrices = payload;
 	},

 	/**
 	 * set newUser state
 	 * @param state
 	 * @param data Data of good
 	 */
 	newGood: (state, data) => {
 		state.newGood = data;
 	},

 	/**
 	 * set Error message
 	 * @param state
 	 * @param data
 	 */
 	createGoodError: (state, data) => {
 		state.createGoodError = data;
 	},

 	/**
 	 * Set List goods
 	 * @param state
 	 * @param data
 	 */
 	setGoods: (state, data) => {
 		data.items.map(item => {
 			item['popover'] = false;
 		});
 		state.items = data.items;
 		state.total = data.total;
 	},
 	setGoodsWithKeyword: (state, data) => {
 		state.goodsForMultiselect = data;
 		state.withKeywordError = false;
 	},
 	fetchGoodsWithKeywordError(state, obj) {
 		state.withKeywordError = obj.message;
 	},
 	setItemWithBarcode(state, item) {
 		state.itemWithBarcode = item;
 		state.barcodeError = false;
 	},
 	withBarcodeError(state, obj) {
 		state.itemWithBarcode = null;
 		state.barcodeError = true;
 	},
 	setBarcodeError(state, boolean) {
 		state.barcodeError = boolean;
 	},
 	setBarcodeTab(state, boolean) {
 		state.isBarcodeTab = boolean;
 	},
 	setColumn(state, data) {
 		state.columns = data
 	},
 	setGoodsForPos(state, data) {
 		state.goodsForPos = data
 	},
 	setGoodsForPosTotal(state, data) {
 		state.forPosTotal = data
 	},
 	setCurrentItem(state, currentEditingItem) {
 		state.currentEditingItem = currentEditingItem;
 	},
 	setCurrentItemImages(state, data) {
 		state.currentEditingItem.images = data;
 	},
 	pushNewPhotoToCurrentItem(state, newImage) {
 		state.currentEditingItem.images.push(newImage);
 	},
 	setPhotoUploadError(state, msgAndBoolean) {
 		state.photoUploadError = msgAndBoolean.message;
 	},
 	deletePhotoFromCurrentItem(state, image) {
 		let foundIndex = state.currentEditingItem.images.findIndex(el => {
 			return el.id == image.id;
 		});
 		if (foundIndex > -1) {
 			state.currentEditingItem.images.splice(foundIndex, 1);
 		}
 	},
 	setPhotoDeleteError(state, msgAndBoolean) {
 		state.photoDeleteError = msgAndBoolean.message;
 	},
 	setMainPhotoForCurrentItem(state, mainImage) {
 		if (mainImage) {
 			state.currentEditingItem.mainPhotoId = mainImage.id;
 		}
 	},
 	setLastWrappedItems(state, data) {
 		state.lastWrappedItems = data;
 	}

 };

 export const goods = {
 	namespaced: true,
 	state,
 	actions,
 	mutations,
 	getters
 };
